import { getLatestShortcodesByLocation } from '../../actions/inventory';

export const LIST_ALL_INVENTORY = 'LIST_ALL_INVENTORY';
export const STORE_ALL_INVENTORY = 'STORE_ALL_INVENTORY';

export const LIST_INVENTORY_ADJUSTMENT_TYPES = 'LIST_INVENTORY_ADJUSTMENT_TYPES';
export const STORE_INVENTORY_ADJUSTMENT_TYPES = 'STORE_INVENTORY_ADJUSTMENT_TYPES';
export const SET_RUN_RATE_CALCULATING = 'SET_RUN_RATE_CALCULATING';

export const LIST_MANUFACTURERS = 'LIST_MANUFACTURERS';
export const STORE_MANUFACTURERS = 'STORE_MANUFACTURERS';

export const LIST_INVENTORY_ALERTS = 'LIST_INVENTORY_ALERTS';
export const STORE_INVENTORY_ALERTS = 'STORE_INVENTORY_ALERTS';

export const CREATE_INVENTORY_ADJUSTMENT = 'CREATE_INVENTORY_ADJUSTMENT';
export const STORE_NEW_INVENTORY_ADJUSTMENT = 'STORE_NEW_INVENTORY_ADJUSTMENT';

export const STORE_NEW_INVENTORY_TRANSFERRED = 'STORE_NEW_INVENTORY_TRANSFERRED';


export const LIST_INVENTORY_ENTRIES = 'LIST_INVENTORY_ENTRIES';
export const STORE_INVENTORY_ENTRIES = 'STORE_INVENTORY_ENTRIES';
export const CLEAR_INVENTORY_ENTRIES = 'CLEAR_INVENTORY_ENTRIES';

export const STORE_NEW_INVENTORY_ENTRY = 'STORE_NEW_INVENTORY_ENTRY';

export const UPDATE_FTL_RECEIVE = 'UPDATE_FTL_RECEIVE';

export const UPDATE_INVENTORY_THRESHOLD = 'UPDATE_INVENTORY_THRESHOLD';
export const RECALCLATE_RUNNING_RATES = 'RECALCLATE_RUNNING_RATES';
export const STORE_UPDATED_INVENTORY_ITEM = 'STORE_UPDATED_INVENTORY_ITEM';

export const LIST_ALL_BOX_INVENTORY = 'LIST_ALL_BOX_INVENTORY';
export const GET_INVENTORY_SUMMARY_FOR_FTL = 'GET_INVENTORY_SUMMARY_FOR_FTL';
export const STORE_ALL_BOX_INVENTORY = 'STORE_ALL_BOX_INVENTORY';
export const STORE_INVENTORY_SUMMARY_FOR_FTL = 'STORE_INVENTORY_SUMMARY_FOR_FTL';
export const LIST_ALL_PRODUCT_INVENTORY = 'LIST_ALL_PRODUCT_INVENTORY';
export const STORE_ALL_PRODUCT_INVENTORY = 'STORE_ALL_PRODUCT_INVENTORY';

export const LIST_ALL_AISLE = 'LIST_ALL_AISLE';
export const STORE_ALL_AISLE = 'STORE_ALL_AISLE'
export const SAVE_AISLE = 'SAVE_AISLE';
export const GET_LATEST_SHORTCODE_LOCATIONS = 'GET_LATEST_SHORTCODE_LOCATIONS';
export const STORE_LATEST_SHORTCODE_LOCATIONS = 'STORE_LATEST_SHORTCODE_LOCATIONS'
export const CONFIRM_INVENTORY_COUNT = 'CONFIRM_INVENTORY_COUNT';

export const GET_ALL_PRODUCT_INVENTORY = 'GET_ALL_PRODUCT_INVENTORY';
export const STORE_ALL_SHORTCODE_INVENTORY = 'STORE_ALL_SHORTCODE_INVENTORY';
